import { convertRawTablesToPlaceholders } from "../helpers/inlineFacts";

/**
 * Migrate old fact format to new format for backward compatibility.
 * Old format: ^fid=xxx^ (with fid= prefix)
 * New format: [[FACT:xxx]]
 *
 * This ensures messages stored in the backend with old format are transparently
 * converted when loaded, without requiring database migration.
 */
export const migrateFactFormat = (text: string): string => {
  if (!text || typeof text !== "string") {
    return text;
  }

  // Pattern: Match ^fid=xxx^ format (with fid= prefix)
  return text.replace(/\^fid=([^^]+)\^/g, "[[FACT:$1]]");
};

/**
 * Apply all text migrations to a rehydrated message.
 * Centralises the transformation chain so every rehydration point stays consistent.
 */
export const migrateMessageContent = (text: string): string =>
  convertRawTablesToPlaceholders(migrateFactFormat(text));
